import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./create-application-location-bl.component.html?ngResource";
import __NG_CLI_RESOURCE__1 from "./create-application-location-bl.component.scss?ngResource";
import { ChangeDetectorRef, Component, ViewChild } from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { SharedConstants } from "../../../../shared/constants/shared.constants";
import { ApplicationCreateService } from "../../../shared/application-create.service";
import { AflaModuleStrategyService } from "../../../../shared/services/afla-module-strategy/afla-module-strategy.service";
import { SelectedApplicationService } from "../../../../shared/services/selected-application/selected-application.service";
import { AppControllerService } from "../../../../app-controller.service";
import { MapService } from "../../../../map/shared/map.service";
import { RequestStatusService } from "../../../../shared/services/request-status/request-status.service";
import { MapTools } from "../../../../map/shared/map.tools";
import { WktConverterUtils } from "../../../../shared/utils/wkt-converter-utils";
import * as JsonUtils from "@arcgis/core/geometry/support/jsonUtils";
import { CreateApplicationUtils } from "../../../shared/utils/create-application-utils";
import { CRUDOperation } from "../../../../shared/models/crud-operation-enum.model";
import { AlertType } from "../../../../shared/models/alert";
import { ApiProxyConstants } from "../../../../shared/constants/api-constants/api-proxy.constants";
import { AppConfig } from "../../../../app.config";
import { AppRoutingConstants } from "../../../../app-routing.constants";
import { UrlConstants } from "../../../../shared/constants/url.constants";
import { CreateApplicationViewBaseComponent } from "../../../shared/create-application-view-base/create-application-view-base.component";
import { CreateApplicationLocationBlConstants } from "./create-application-location-bl.constants";
import { debounceTime } from "rxjs";
import { SearchApplicationsService } from "../../../../search-applications/shared/search-applications.service";
import { AutoUnsubPortal } from "../../../../shared/decorators/autounsub-portal.decorator";
let CreateApplicationLocationBlComponent = class CreateApplicationLocationBlComponent extends CreateApplicationViewBaseComponent {
    applicationCreateService;
    aflaModuleStrategyService;
    selectedApplicationService;
    appController;
    mapService;
    requestStatusService;
    mapTools;
    changeDetectorRefs;
    searchApplicationsService;
    active;
    propertiesForm;
    descriptionLabel1 = CreateApplicationLocationBlConstants.DESCRIPTION_LABEL_1;
    descriptionLabel2 = CreateApplicationLocationBlConstants.DESCRIPTION_LABEL_2;
    descriptionLabel3 = CreateApplicationLocationBlConstants.DESCRIPTION_LABEL_3;
    validationMessages = CreateApplicationLocationBlConstants.VALIDATION_MESSAGES;
    erfNoControl = CreateApplicationLocationBlConstants.ERF_NO_CONTROL;
    propertiesFormGroupName = CreateApplicationLocationBlConstants.PROPERTIES_FORM_GROUP_NAME;
    propertiesFormControlName = CreateApplicationLocationBlConstants.PROPERTIES_FORM_CONTROL;
    subdivisionControl = CreateApplicationLocationBlConstants.SUBDIVISION_CONTROL;
    allotmentControl = CreateApplicationLocationBlConstants.ALLOTMENT_CONTROL;
    farmNoControl = CreateApplicationLocationBlConstants.FARM_NO_CONTROL;
    sgCodeControl = CreateApplicationLocationBlConstants.SG_CODE_CONTROL;
    addressControl = CreateApplicationLocationBlConstants.ADDRESS_CONTROL;
    unitNumberControl = CreateApplicationLocationBlConstants.UNIT_NUMBER_CONTROL;
    shopNumberControl = CreateApplicationLocationBlConstants.SHOP_NUMBER_CONTROL;
    titleDeedNumberControl = CreateApplicationLocationBlConstants.TITLE_DEED_NUMBER_CONTROL;
    titleDeedDescriptionNumberControl = CreateApplicationLocationBlConstants.TITLE_DEED_DESCRIPTION_CONTROL;
    erfNoTextPlaceHolder = CreateApplicationLocationBlConstants.ERF_NO_TEXT_PLACEHOLDER;
    subdivisionTextPlaceHolder = CreateApplicationLocationBlConstants.SUBDIVISION_TEXT_PLACEHOLDER;
    allotmentTextPlaceHolder = CreateApplicationLocationBlConstants.ALLOTMENT_TEXT_PLACEHOLDER;
    farmNoTextPlaceHolder = CreateApplicationLocationBlConstants.FARM_NO_TEXT_PLACEHOLDER;
    sgCodeTextPlaceHolder = CreateApplicationLocationBlConstants.SG_CODE_TEXT_PLACEHOLDER;
    addressTextPlaceHolder = CreateApplicationLocationBlConstants.ADDRESS_TEXT_PLACEHOLDER;
    unitNumberPlaceHolder = CreateApplicationLocationBlConstants.UNIT_NUMBER_PLACEHOLDER;
    erfSizeTextPlaceHolder = CreateApplicationLocationBlConstants.ERF_SIZE_TEXT_PLACEHOLDER;
    shopNumberTextPlaceHolder = CreateApplicationLocationBlConstants.SHOP_NUMBER_TEXT_PLACEHOLDER;
    titleDeedNumberTextPlaceHolder = CreateApplicationLocationBlConstants.TITLE_DEED_NUMBER_TEXT_PLACEHOLDER;
    nameOfAccommodationTextPlaceholder = CreateApplicationLocationBlConstants.NAME_OF_ACCOMMODATION_TEXT_PLACEHOLDER;
    nameOfAccommodationControl = CreateApplicationLocationBlConstants.NAME_OF_ACCOMMODATION_CONTROL;
    titleDeedDescriptionTextPlaceHolder = CreateApplicationLocationBlConstants.TITLE_DEED_DESCRIPTION_TEXT_PLACEHOLDER;
    dropdownPlaceholderMessage = SharedConstants.PLACEHOLDER_TEXT;
    removePropertyLabel = CreateApplicationLocationBlConstants.REMOVE_PROPERTY_LABEL;
    subdivisionControlRequired = true;
    farmNoControlRequired = true;
    erfNoControlRequired = true;
    mapComponent;
    isMapLoaded = false;
    layerReference = CreateApplicationLocationBlConstants.LAYER_REF;
    hasLoadedApplicationProperties = false;
    selectedPropertySubscription;
    getTrueCentroidSubscription;
    clearLayerGraphicsSubjectSubscription;
    applicationCreateServiceSubscription;
    constructor(applicationCreateService, aflaModuleStrategyService, selectedApplicationService, appController, mapService, requestStatusService, mapTools, changeDetectorRefs, searchApplicationsService) {
        super(applicationCreateService, aflaModuleStrategyService, selectedApplicationService, searchApplicationsService);
        this.applicationCreateService = applicationCreateService;
        this.aflaModuleStrategyService = aflaModuleStrategyService;
        this.selectedApplicationService = selectedApplicationService;
        this.appController = appController;
        this.mapService = mapService;
        this.requestStatusService = requestStatusService;
        this.mapTools = mapTools;
        this.changeDetectorRefs = changeDetectorRefs;
        this.searchApplicationsService = searchApplicationsService;
    }
    getProperties() {
        return this.propertiesForm.get(this.propertiesFormControlName);
    }
    ngAfterViewInit() {
        this.mapService.actionPropertyEnabled = true;
    }
    ngOnInit() {
        this.initForm();
        this.getMetadata();
        if (this.propertiesForm.pristine && this.isApplicationLoadedFromTheSearchPage) {
            // this is either the first time this step is loaded or it is being loaded from the search page
            this.checkApplicationData();
        }
        this.setupSubscribers();
        this.changeDetectorRefs.detectChanges();
    }
    mapLoaded() {
        this.isMapLoaded = true;
        this.syncMapGeometries();
    }
    loadMetadata() {
    }
    onBtnRemoveSelectedPropertyClicked(propertyIndex) {
        this.getProperties().removeAt(propertyIndex);
        this.syncMapGeometries();
        this.changeDetectorRefs.detectChanges();
    }
    setNumberToDecimal(control, event) {
        //  sets number to two decimal places
        const value = event.target.value;
        const decimalValue = parseFloat(value).toFixed(2);
        control.setValue(decimalValue);
    }
    updateRequiredFields(propertyIndex) {
        const propertyControl = this.getProperties().controls[propertyIndex];
        const erfNoControl = propertyControl.get(this.erfNoControl);
        const farmNoControl = propertyControl.get(this.farmNoControl);
        const subdivisionControl = propertyControl.get(this.subdivisionControl);
        if (erfNoControl.value !== undefined && erfNoControl.value !== null && erfNoControl.value.trim() !== "") {
            erfNoControl.setValidators(Validators.required);
            farmNoControl.clearValidators();
            subdivisionControl.clearValidators();
            farmNoControl.setValue("");
            subdivisionControl.setValue("");
            farmNoControl.disable();
            farmNoControl.clearValidators();
            subdivisionControl.disable();
            subdivisionControl.markAsUntouched();
            farmNoControl.markAsUntouched();
            this.subdivisionControlRequired = false;
            this.farmNoControlRequired = false;
            this.erfNoControlRequired = true;
        }
        else if ((farmNoControl.value !== undefined && farmNoControl.value !== null && farmNoControl.value.trim() !== "") ||
            (subdivisionControl.value !== undefined && subdivisionControl.value !== null && subdivisionControl.value.trim() !== "")) {
            farmNoControl.setValidators(Validators.required);
            subdivisionControl.setValidators(Validators.required);
            erfNoControl.clearValidators();
            erfNoControl.setValue("");
            erfNoControl.clearValidators();
            erfNoControl.disable();
            erfNoControl.markAsUntouched();
            this.subdivisionControlRequired = true;
            this.farmNoControlRequired = true;
            this.erfNoControlRequired = false;
        }
        else {
            erfNoControl.setValidators(Validators.required);
            farmNoControl.setValidators(Validators.required);
            subdivisionControl.setValidators(Validators.required);
            erfNoControl.enable();
            farmNoControl.enable();
            subdivisionControl.enable();
            erfNoControl.markAsUntouched();
            subdivisionControl.markAsUntouched();
            farmNoControl.markAsUntouched();
            this.subdivisionControlRequired = true;
            this.farmNoControlRequired = true;
            this.erfNoControlRequired = true;
        }
        const sgCodeControl = propertyControl.get(this.sgCodeControl);
        if (sgCodeControl.value !== null && sgCodeControl.value !== undefined && sgCodeControl.value !== "") {
            sgCodeControl.disable();
        }
        else {
            sgCodeControl.enable();
        }
        this.changeDetectorRefs.detectChanges();
    }
    initForm() {
        this.propertiesForm = this.aflaModuleStrategyService.form.get(this.propertiesFormGroupName);
    }
    syncMapGeometries() {
        const geometries = [];
        this.getProperties().controls.forEach(item => {
            const geom = item.get("geometry").value;
            if (geom !== null) {
                geometries.push(geom);
            }
        });
        if (geometries.length > 0) {
            this.mapComponent.addGeometriesOnMap(geometries, this.layerReference, true);
        }
    }
    setupSubscribers() {
        this.subscribeToProperty();
        this.subscribeToClearGraphics();
        this.subscribeToCheckFormValidity();
    }
    subscribeToClearGraphics() {
        this.clearLayerGraphicsSubjectSubscription = this.applicationCreateService.$clearLayerGraphicsSubject.subscribe({
            next: (clearGraphics) => {
                if (clearGraphics) {
                    this.getProperties().clear();
                    this.mapComponent.removeGraphicsFromMap(this.layerReference);
                    this.mapTools.sketchGraphicsLayer.removeAll();
                    this.changeDetectorRefs.detectChanges();
                }
            }
        });
    }
    updateComponentData() {
        if (+this.jobId > 0 && this.selectedApplication) {
            const propertyControl = this.getProperties();
            let tabIndex = 0;
            this.selectedApplication.properties.sort((a, b) => (b?.id - a?.id));
            this.selectedApplication.properties.forEach(savedProperty => {
                const geometryArc = WktConverterUtils.ConvertWktToArcGisJson(savedProperty.shape, 102100);
                const geom = JsonUtils.fromJSON(geometryArc);
                const newPropertyFormGroup = this.getUpdatedPropertiesFormGroup(savedProperty, geom);
                this.propertiesForm.markAllAsTouched();
                this.applicationCreateService.getPropertyCentroidObservable(geom).subscribe({
                    next: (trueCentroidResponse) => {
                        CreateApplicationUtils.handleTrueCentroidResponse(trueCentroidResponse, newPropertyFormGroup);
                        propertyControl.push(newPropertyFormGroup);
                        this.active = propertyControl.length - 1;
                        this.updateRequiredFields(this.active);
                        this.syncMapGeometries();
                        CreateApplicationUtils.updatePropertyIds(this.selectedApplication, this.propertiesForm);
                        this.changeDetectorRefs.detectChanges();
                    }, error: (error) => {
                        this.appController.handleServerErrorMessage(CreateApplicationLocationBlConstants.TRUE_CENTROID, error, CRUDOperation.Get);
                    }
                });
                tabIndex++;
            });
            if (this.isMapLoaded) {
                this.syncMapGeometries();
            }
            this.hasLoadedApplicationProperties = true;
            this.changeDetectorRefs.detectChanges();
        }
    }
    subscribeToProperty() {
        this.selectedPropertySubscription = this.mapService.$selectedProperty.pipe(debounceTime(1000)).subscribe(property => {
            if (property !== null) {
                this.setPropertyData(property.attributes, property.geometry);
            }
        });
    }
    setPropertyData(propertyObject, geometry) {
        this.requestStatusService.showBusySpinner("SetPropertyData");
        const sgCode = CreateApplicationUtils.propertyDataAlternateColumnName(propertyObject, "SgCode", "sgCode");
        const objectId = CreateApplicationUtils.propertyDataAlternateColumnName(propertyObject, "OBJECTID", "objectid");
        let found = false;
        this.getProperties().controls.forEach(item => {
            const check = item.get("objectId").value;
            if (check === objectId) {
                found = true;
                this.appController.showMessage(CreateApplicationLocationBlConstants.DUPLICATE_MESSAGE, AlertType.Warning);
                this.requestStatusService.removeBusySpinner("SetPropertyData");
            }
        });
        if (!found) {
            const newProperty = new FormGroup({
                id: new FormControl(0),
                objectId: new FormControl(CreateApplicationUtils.propertyDataAlternateColumnName(propertyObject, "OBJECTID", "objectid")),
                erfNo: new FormControl(CreateApplicationUtils.propertyDataAlternateColumnName(propertyObject, "ErfNo", "erno")),
                subdivision: new FormControl(CreateApplicationUtils.propertyDataAlternateColumnName(propertyObject, "PtnNum", "ptnnum"), [Validators.required]),
                allotment: new FormControl(CreateApplicationUtils.propertyDataAlternateColumnName(propertyObject, "Allotment", "allotment"), [Validators.required]),
                farmNo: new FormControl(CreateApplicationUtils.propertyDataAlternateColumnName(propertyObject, "FarmNo", "farmno")),
                sgCode: new FormControl(sgCode, [Validators.required]),
                address: new FormControl(CreateApplicationUtils.propertyDataAlternateColumnName(propertyObject, "Address", "address"), [Validators.required]),
                geometry: new FormControl(geometry),
                unitNumber: new FormControl(CreateApplicationUtils.propertyDataAlternateColumnName(propertyObject, "UnitNumber", "unitnumber")),
                shopNumber: new FormControl(null),
                accommodationName: new FormControl(null),
                titleDeedNumber: new FormControl(null, Validators.required),
                titleDeedDescription: new FormControl(CreateApplicationUtils.propertyDataAlternateColumnName(propertyObject, "TitleDeed", "titledeed"), Validators.required),
                centroid: new FormControl(null, [Validators.required])
            });
            const proxyUrl = ApiProxyConstants.URL;
            const gpToolUrl = AppConfig.settings.arcGIS.servicesURL + AppRoutingConstants.ROUTE_SEPERATOR + UrlConstants.GEO_PROCESSING + AppRoutingConstants.ROUTE_SEPERATOR + UrlConstants.GET_TRUE_CENTROID + AppRoutingConstants.ROUTE_SEPERATOR + UrlConstants.GP_SERVER + AppRoutingConstants.ROUTE_SEPERATOR + UrlConstants.GET_TRUE_CENTROID + AppRoutingConstants.ROUTE_SEPERATOR + UrlConstants.EXECUTE;
            const url = `${proxyUrl}?${gpToolUrl}`;
            const formData = new FormData();
            formData.append("f", "json");
            formData.append("geometryJSON", JSON.stringify(geometry));
            this.getTrueCentroidSubscription = this.applicationCreateService.getTrueCentroid(url, formData)
                .subscribe((trueCentroidResponse) => {
                newProperty.get("centroid").setValue(trueCentroidResponse.results[0].value);
                this.handleAddProperty(newProperty);
            });
        }
    }
    handleAddProperty(newProperty) {
        const propertyControl = this.getProperties();
        propertyControl.push(newProperty);
        if (this.getProperties().controls.length > 1) {
            this.requestStatusService.removeBusySpinner("GetPropertyDate");
            this.appController.showMessage(CreateApplicationLocationBlConstants.ONLY_ONE_PROPERTY_ALLOWED, AlertType.Warning);
            return;
        }
        this.active = propertyControl.length - 1;
        this.updateRequiredFields(this.active);
        this.changeDetectorRefs.detectChanges();
        this.syncMapGeometries();
        this.requestStatusService.removeBusySpinner("GetPropertyDate");
    }
    getUpdatedPropertiesFormGroup(savedProperty, geom) {
        return new FormGroup({
            id: new FormControl(savedProperty.id),
            erfNo: new FormControl(savedProperty.erfNumber),
            subdivision: new FormControl(savedProperty.subdivision),
            allotment: new FormControl(savedProperty.allotment, [Validators.required]),
            farmNo: new FormControl(savedProperty.farmNumber),
            address: new FormControl(savedProperty.address, [Validators.required]),
            sgCode: new FormControl(savedProperty.sgCode, [Validators.required]),
            geometry: new FormControl(geom),
            unitNumber: new FormControl(savedProperty.unitNumber),
            shopNumber: new FormControl(savedProperty.shopNumber),
            accommodationName: new FormControl(savedProperty.accommodationName),
            titleDeedNumber: new FormControl(savedProperty.titleDeedNumber, Validators.required),
            titleDeedDescription: new FormControl(savedProperty.titleDeedDescription, Validators.required),
            centroid: new FormControl(null, [Validators.required])
        });
    }
    checkApplicationData() {
        const isFormPristine = this.propertiesForm.pristine;
        const isFormUnTouched = this.propertiesForm.untouched;
        const isFormInvalid = this.propertiesForm.invalid;
        if (isFormPristine && isFormUnTouched && isFormInvalid) {
            this.updateComponentData();
        }
    }
    subscribeToCheckFormValidity() {
        this.applicationCreateServiceSubscription = this.applicationCreateService.$markStepFormGroupAsTouchedSubscription.subscribe({
            next: (formGroupName) => {
                if (formGroupName && this.propertiesForm && formGroupName === this.propertiesFormGroupName) {
                    this.propertiesForm.markAllAsTouched();
                    this.changeDetectorRefs.markForCheck();
                }
            }
        });
    }
    static ctorParameters = () => [
        { type: ApplicationCreateService },
        { type: AflaModuleStrategyService },
        { type: SelectedApplicationService },
        { type: AppControllerService },
        { type: MapService },
        { type: RequestStatusService },
        { type: MapTools },
        { type: ChangeDetectorRef },
        { type: SearchApplicationsService }
    ];
    static propDecorators = {
        mapComponent: [{ type: ViewChild, args: ["esrimap", { static: true },] }]
    };
};
CreateApplicationLocationBlComponent = __decorate([
    Component({
        selector: "app-create-application-location-bl",
        template: __NG_CLI_RESOURCE__0,
        styles: [__NG_CLI_RESOURCE__1]
    }),
    AutoUnsubPortal()
], CreateApplicationLocationBlComponent);
export { CreateApplicationLocationBlComponent };
